import { render, staticRenderFns } from "./FounderThoghts.vue?vue&type=template&id=88d75e08"
import script from "./FounderThoghts.vue?vue&type=script&lang=js"
export * from "./FounderThoghts.vue?vue&type=script&lang=js"
import style0 from "./FounderThoghts.vue?vue&type=style&index=0&id=88d75e08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports